import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectHasCallWidgets } from 'flow/selectors/call-widget-selectors';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { PageType } from 'flow/components/call-history-v2/types';
import SectionTitle from '../SectionTitle';
import CardCallDetailsContainer from '../../misc/CardCallDetailsContainer';
import CallRecordDetails from '../../pbx-queue-items/history/call-record/CallRecordDetails';
import CallRecordWidgetContextMenu from 'flow/components/call-history-v2/CallRecordWidgetContextMenu';

interface Props {
    callRecordKey: CallRecordKey;
    pageType: PageType;
}

const SectionCallDetails = ({ callRecordKey, pageType }: Props) => {
    const { i18next } = useAppContext();
    const hasCallWidgets = useAppSelector(selectHasCallWidgets);

    return (
        <CardCallDetailsContainer className="flex-col gap-1">
            <div className="relative flex items-center justify-between">
                <SectionTitle title={i18next.t('Chat.Details.Title')} />
                {hasCallWidgets && (
                    <div className="absolute end-0 -top-1">
                        <CallRecordWidgetContextMenu
                            callRecordKey={callRecordKey}
                        />
                    </div>
                )}
            </div>
            <CallRecordDetails
                callRecordKey={callRecordKey}
                showCaller={true}
                pageType={pageType}
            />
        </CardCallDetailsContainer>
    );
};

export default SectionCallDetails;
